import { MARQUEE } from "@/lib/content";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-line py-7" aria-hidden="true">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((k) => (
          <div key={k} className="flex">
            {items.map((t, i) => (
              <span key={`${k}-${i}`} className="font-display flex items-center px-8 text-sm uppercase tracking-[0.3em] text-zinc-400">
                {i % 2 ? <span className="font-serif-i normal-case tracking-normal text-2xl text-zinc-300">{t}</span> : t}
                <span className="ml-16 inline-block h-1.5 w-1.5 bg-cta" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
